/**
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 * Sectors - Giti 
 * -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
 */
module.exports = {
  "Gatobotobo": ["Kababito", "Kabacuzi", "Kagahumbi", "Matyazo", "Nyamirambo", "Rugarama"],
  "Murehe": ["Bisika", "Bushiranyota", "Butare", "Cyamabano", "Gatare", "Kabeza", "Kigabiro"],
  "Tanda": ["Gasharu", "Mashyoza", "Nganwa", "Nyakabungo", "Ruzizi", "Tanda"]
};